import React, { Component } from "react";
import PropTypes from "prop-types";
import { Mutation } from "react-apollo";

import { Fieldset, Field, Label, Control, Input, Textarea } from "rbx";
import Section from "../Section";
import { EditFormButtonGroup } from "../inputs";

import {
  UPDATE_LOCATION_TANK_MUTATION,
  DELETE_LOCATION_TANK_MUTATION
} from "../../graphql/Locations/LocationTanks.graphql";

import { ErrorMessage } from "../ErrorMessage";

class EditLocationTankForm extends Component {
  state = {
    Description: "",
    Quantity: "",
    Size: "",
    ...this.props.tank
  };

  onChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value });
  };

  render() {
    const { onComplete } = this.props;
    const { Description, Quantity, Size } = this.state;
    return (
      <Mutation
        mutation={UPDATE_LOCATION_TANK_MUTATION}
        refetchQueries={["ALL_LOCATION_TANKS_QUERY"]}
        variables={{
          data: {
            Description,
            Quantity: parseInt(Quantity),
            Size: parseInt(Size)
          },
          where: {
            RecId: this.props.tank.RecId
          }
        }}
      >
        {(updateLocationTank, { loading, error }) => (
          <Section title="Edit Location Tank">
            <form
              id="edit-location-tank"
              onSubmit={async e => {
                e.preventDefault();
                await updateLocationTank();
                onComplete();
              }}
            >
              <ErrorMessage error={error} />
              <Fieldset disabled={loading}>
                <Field kind="group">
                  <Control expanded>
                    <Label>Quantity</Label>
                    <Input
                      autocomplete="new"
                      min="0"
                      name="Quantity"
                      type="number"
                      value={Quantity}
                      onChange={this.onChange}
                    />
                  </Control>
                  <Control expanded>
                    <Label>Size</Label>
                    <Input
                      autocomplete="new"
                      name="Size"
                      type="text"
                      value={Size}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <Field>
                  <Control>
                    <Label>Description</Label>
                    <Textarea
                      name="Description"
                      rows="3"
                      value={Description}
                      onChange={this.onChange}
                    />
                  </Control>
                </Field>
                <EditFormButtonGroup
                  deleteMutation={DELETE_LOCATION_TANK_MUTATION}
                  form="edit-location-tank"
                  refetchQueries={["ALL_LOCATION_TANKS_QUERY"]}
                  variables={{ where: { RecId: this.props.tank.RecId } }}
                  onComplete={onComplete}
                />
              </Fieldset>
            </form>
          </Section>
        )}
      </Mutation>
    );
  }
}

EditLocationTankForm.propTypes = {
  onComplete: PropTypes.func,
  tank: PropTypes.object
};
export default EditLocationTankForm;
